// The native v2 session owns refresh rotation; web receives short-lived access.
export const LEGACY_NATIVE_SESSION_PROTOCOL_VERSION = 1 as const;
export const NATIVE_REFRESH_BROKER_PROTOCOL_VERSION = 2 as const;
export const NATIVE_SESSION_MODE_HOST_ONLY_V1 = "host-only-v1" as const;

type NativeCapabilities = {
    supportsIntegratedMessenger?: boolean;
    protocolVersion?: number;
    supportsSessionBundle?: boolean;
    supportsNativeRefreshBroker?: boolean;
    nativeSessionMode?: string;
};

export function isInWebView(): boolean {
    return typeof window !== "undefined" &&
        typeof (window as any).ReactNativeWebView?.postMessage === "function";
}

export function getNativeCapabilities(): NativeCapabilities {
    const value = typeof window !== "undefined" ? (window as any).__CC_NATIVE_CAPABILITIES__ : null;
    return value && typeof value === "object" ? value : {};
}

export function usesNativeRefreshOwnership(): boolean {
    const version = getNativeCapabilities().protocolVersion;
    return typeof version === "number" && version >= NATIVE_REFRESH_BROKER_PROTOCOL_VERSION;
}

export function getNativeSessionEpoch(): number | undefined {
    const value = typeof window !== "undefined" ? (window as any).__CC_NATIVE_SESSION_CONTEXT__?.sessionEpoch : undefined;
    return typeof value === "number" && Number.isFinite(value) && value >= 0
        ? Math.floor(value)
        : undefined;
}

type NativeBridgePayloads = {
    native_capability_probe: { requestId: string };
    native_refresh_request: { requestId: string };
    open_native_messenger: Record<string, never>;
    native_messenger_ui_ready: { navigation: "franchisee" };
};
export function postToNative<T extends keyof NativeBridgePayloads>(
    type: T,
    data: NativeBridgePayloads[T],
    options: { includeSessionEpoch?: boolean } = {},
): boolean {
    if (!isInWebView()) return false;
    const epoch = options.includeSessionEpoch === false ? undefined : getNativeSessionEpoch();
    try {
        (window as any).ReactNativeWebView.postMessage(JSON.stringify({
            v: 1, type, data, ...(epoch == null ? {} : { epoch }),
        }));
        return true;
    } catch {
        return false;
    }
}
